import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconTick: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ?? 12}
      height={height ?? 9}
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3317 0.664978L3.99837 7.99831L0.665039 4.66498"
        stroke={color ?? "#F8FAFC"}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
